import {
  EServiceType,
  IServicePackageItemV4,
} from '../../../../repositories/billing-service-packages-balancer/entities/Purchase/ServicePackageItemV4';
import { IRecommendedPackageService } from '../../../../types/reducers/recommendedPackages';
import { mapPublicServiceType } from '../../../../utils/publishTerms';
import { lowerFirst } from '../../../../utils/string';

export const mapItem = (service: IRecommendedPackageService): IServicePackageItemV4 => {
  const { count } = service;

  const serviceType = mapPublicServiceType(service.serviceType)!;

  return {
    count,
    serviceType: lowerFirst(serviceType) as EServiceType,
  };
};
